module.exports = __webpack_public_path__ + "img/axis-logo.c7205969.png";